export enum EMAIL_ID {
  OB5L = "OB5L",
  OB1L = "OB1L",
  OB2L = "OB2L",
  OB3L = "OB3L",
  OB7L = "OB7L",

  OB5H = "OB5H",
  OB1H = "OB1H",

  G1L = "G1L",
  G2L = "G2L",
  G3L = "G3L",
  G4L = "G4L",
  G10L = "G10L",
  G11L = "G11L",
  G12L = "G12L",
  G14L = "G14L",
  G16L = "G16L",
  G18L = "G18L",
  G19L = "G19L",
  G21L = "G21L",
  G23L = "G23L",
  G25L = "G25L",
  G27L = "G27L",

  // Comoon Referral Mails
  RE1C = "RE1C",
}
